import $ from 'cash-dom';
import inView from 'in-view';

export default () => {
  let boxContentTimer;
  let boxContentTimerDisabled = false;

  function startBoxContentTimer() {
    if (!boxContentTimerDisabled) {
      const $contents = $('.js-box-content');
      const activeContents = $contents.filter('.is-active');
      const activeContent = activeContents.length && activeContents[0];
      const activeIndex = activeContent ? $contents.index(activeContent) : $contents.length - 1;
      const nextIndex = activeIndex < $contents.length - 1 ? activeIndex + 1 : 0;
      if (activeContent) {
        $(activeContent).removeClass('is-active');
      }
      $contents[nextIndex].click();

      boxContentTimer = setTimeout(startBoxContentTimer, 5000);
    }
  }

  $('.js-box-content').on('click', (evt) => {
    if (evt.isTrusted) { // detect non-emulated click
      boxContentTimerDisabled = true;
      if (boxContentTimer) {
        clearTimeout(boxContentTimer);
        boxContentTimer = null;
      }
    }
  });
  inView('.home-find__content')
    .on('enter', () => {
      console.log('Enter');
      boxContentTimer = setTimeout(startBoxContentTimer, 2000);
    })
    .on('exit', () => {
      console.log('Leave');
      if (boxContentTimer) {
        clearTimeout(boxContentTimer);
        boxContentTimer = null;
      }
    });
};
